// API ROOT URL
// export const API_ROOT_URL = "https://api.farmakom.it/v1/sales";
// export const API_ROOT_URL = "http://127.0.0.1:8087/v1/sales";
// export const API_ROOT_URL = "http://0.0.0.0:8087/v1/sales";
// export const API_ROOT_URL = "http://localhost:8087/v1/sales";
export const API_ROOT_URL = "https://api.farmakom.thecove.it/v1/sales";
// export const API_ROOT_URL = "http://vps725543.ovh.net:8087/v1/sales";

// export const API_CONTRACT_URL = "https://api.farmakom.it/contracts/";
export const API_CONTRACT_URL = "https://api.farmakom.thecove.it/contracts/";

// LOCAL LOGIN
// If true it doesn't redirect to the external URL (for local testing)
export const LOCAL_LOGIN = true;
